import { safeJson } from "src/app/helpers/Index";
import { faPencil, faPeopleGroup, faTrash } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FilterMatchMode } from "primereact/api";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { InputSwitch } from "primereact/inputswitch";
import { TabPanel, TabView } from "primereact/tabview";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import React from "react";
import { ResizeImage } from "src/app/helpers/ResizeImage";
import { Col, Nav, Row } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import { Card, Fixture, Goal, Player, Sponsor, Substitute, Team } from "src/app/interfaces/Index";
import { CompetitionService, FileService, FixtureService, PlayerService, SeasonService, SponsorService, TeamService } from "src/app/services/Index";
import { colours } from "src/app/Styles";
import { CanvasToA4Pdf } from "src/app/helpers/CanvasToPdf";
import { CLUB_SETTING_LEAGUE_IMAGE, CLUB_SETTING_NAME, CLUB_SETTING_PRIMARY_COLOUR, CLUB_SETTING_TEAMSHEET_SPONSOR_IMAGE, ClubSettingService } from "src/app/services/ClubSettingService";
import { environment } from "src/environments/environment";
import "./AdminFixtures.css";
import { ok } from "assert";
import { GoalService } from "src/app/services/GoalService";
import { SubstituteService } from "src/app/services/SubstituteService";
import { CardService } from "src/app/services/Index";
import { CardType } from "src/app/enums/CardType";

type Props = {
	/** Render only the matchday editor, for a fixture the parent has chosen. */
	embedded?: boolean;
	fixtureId?: number;
};
type State = {
	isLoading: boolean;
	awayPlayers: Player[];
	calendarMonth: Date;
	viewMode: string;
	awayScorerId: number;
	awayPlayerCardId: number;
	awayPlayerOffId: number;
	awayPlayerOnId: number;
	cards: Card[];
	filters1: any;
	goals: Goal[];
	globalFilter: string;
	masterItems: Fixture[];
	items: Fixture[];
	homePlayers: Player[];
	homeScorerId: number;
	homePlayerCardId: number;
	homePlayerOffId: number;
	homePlayerOnId: number;
	selectedCard: Card;
	selectedGoal: Goal;
	selectedItem: Fixture;
	selectedItems: Fixture[];
	selectedSub: Substitute;
	showDeleteCardModal: boolean;
	showDeleteGoalModal: boolean;
	showDeleteSubModal: boolean;
	showDeleteModal: boolean;
	showDeleteSelectionModal: boolean;
	showItemInfoModal: boolean;
	showPlayers: boolean;
	sponsors: Sponsor[];
	submitted: boolean;
	substitute: Substitute;
	substitutes: Substitute[];
	teams: Team[];
	competitions: any[];
	seasons: any[];
};

export class AdminFixtures extends React.Component<Props, State> {
	dt: any;
	toast: any;
	itemName: string = "Fixture";
	itemNamePlural: string = "Fixtures";

	constructor(props: Props) {
		super(props);
		this.state = { isLoading: false, awayPlayers: [], calendarMonth: new Date(), viewMode: "calendar", cards: [], filters1: { "global": { value: null, matchMode: FilterMatchMode.CONTAINS } }, goals: [], globalFilter: "", masterItems: [], homePlayers: [], awayScorerId: 0, awayPlayerCardId:0 ,awayPlayerOffId: 0, awayPlayerOnId: 0, homePlayerCardId:0, homePlayerOffId: 0, homePlayerOnId: 0, homeScorerId: 0, selectedCard: new Card, selectedGoal: new Goal, selectedItem: new Fixture(), selectedItems: [], selectedSub: new Substitute, items: [],showDeleteCardModal: false, showDeleteGoalModal: false, showDeleteModal: false, showDeleteSelectionModal: false, showDeleteSubModal: false, showItemInfoModal: false, showPlayers: false, sponsors: [], submitted: false, substitute: new Substitute, substitutes: [], teams: [], competitions: [], seasons: [] };
	}

	componentDidMount() {
		this.getTeams();
		this.getCompetitions();
		this.getSeasons();
		this.getHomePlayers();
		this.getSponsors();
		this.getItems();
	}

	componentDidUpdate(prev: Props) {
		// Embedded: follow whichever fixture the Fixtures screen has selected.
		if (this.props.embedded && this.props.fixtureId && this.props.fixtureId !== prev.fixtureId) {
			this.openFixtureById(this.props.fixtureId);
		}
	}

	openFixtureById(id: number) {
		const fixture = (this.state.items || []).find((x: any) => x.id === id);
		if (fixture) this.openItemModal(fixture);
	}

	async createCard(homeOffender: boolean, isYellow: boolean) {
		let card = new Card;

		if (homeOffender) card.playerId = this.state.homePlayerCardId;
		else card.playerId = this.state.awayPlayerCardId;
		if (isYellow) card.cardType = CardType.Yellow
		else card.cardType = CardType.Red
		card.fixtureId = this.state.selectedItem.id

		if (card.playerId !== undefined && card.playerId > 0) {
			const res = await safeJson(CardService.createSingle(card));
			if (res && res.error) {
				this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
				this.setState({ isLoading: false });
			}
			this.setState({ isLoading: false });
			this.getCards(card.fixtureId);
			this.toast.show({ closable: false, detail: "Card has been created", life: 5000, severity: "success", summary: "Card created!" });
		} else {
			this.toast.show({ closable: false, detail: "No player selected.", life: 5000, severity: "error", summary: "Create Card" });
			this.setState({ isLoading: false });
		}

	}


	async createGoal(homeGoal: boolean) {
		let goal = new Goal;

		if (homeGoal) goal.playerId = this.state.homeScorerId;
		else goal.playerId = this.state.awayScorerId;
		goal.fixtureId = this.state.selectedItem.id

		if (goal.playerId !== undefined && goal.playerId > 0) {
			const res = await safeJson(GoalService.createSingle(goal));
			if (res && res.error) {
				this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
				this.setState({ isLoading: false });
			}
			this.setState({ isLoading: false });
			this.getGoals(goal.fixtureId);
			this.toast.show({ closable: false, detail: "Goal has been created", life: 5000, severity: "success", summary: "Goal created!" });
		} else {
			this.toast.show({ closable: false, detail: "No player selected.", life: 5000, severity: "error", summary: "Create Goal" });
			this.setState({ isLoading: false });
		}

	}

	async createSubstitute(homeSub: boolean) {
		let sub = new Substitute;

		if (homeSub) {
			sub.playerOffId = this.state.homePlayerOffId;
			sub.playerOnId = this.state.homePlayerOnId;
		} else {
			sub.playerOffId = this.state.awayPlayerOffId;
			sub.playerOnId = this.state.awayPlayerOnId;

		}
		sub.fixtureId = this.state.selectedItem.id

		if ((sub.playerOffId !== undefined && sub.playerOffId > 0) && (sub.playerOnId !== undefined && sub.playerOnId > 0)) {
			const res = await safeJson(SubstituteService.createSingle(sub));
			if (res && res.error) {
				this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
				this.setState({ isLoading: false });
			}
			this.setState({ isLoading: false, awayPlayerOffId: 0, awayPlayerOnId: 0, homePlayerOffId: 0, homePlayerOnId: 0 });
			this.getSubstitutions(sub.fixtureId);
			this.getHomePlayers();
			this.getAwayPlayers(this.state.selectedItem.teamId);
			this.toast.show({ closable: false, detail: "Substitution has been created", life: 5000, severity: "success", summary: "Substitution created!" });
		} else {
			this.toast.show({ closable: false, detail: "No players selected.", life: 5000, severity: "error", summary: "Create Substitution" });
			this.setState({ isLoading: false });
		}

	}

	deleteCardFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="No" onClick={() => this.setState({ showDeleteCardModal: false })}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Yes" onClick={(data) => this.deleteCardConfirm(data)}></Button>
			</>
		);
	}
	
	deleteGoalFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="No" onClick={() => this.setState({ showDeleteGoalModal: false })}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Yes" onClick={(data) => this.deleteGoalConfirm(data)}></Button>
			</>
		);
	}

	deleteSubFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="No" onClick={() => this.setState({ showDeleteSubModal: false })}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Yes" onClick={(data) => this.deleteSubConfirm(data)}></Button>
			</>
		);
	}

	deleteItemFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="No" onClick={() => this.setState({ showDeleteModal: false })}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Yes" onClick={(data) => this.deleteItemConfirm(data)}></Button>
			</>
		);
	}

	deleteItemsFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="No" onClick={() => this.setState({ showDeleteSelectionModal: false })}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Yes" onClick={() => this.deleteSelectedItemConfirm()}></Button>
			</>
		);
	}

	async deleteCardConfirm(rowData: any) {
		const res = await (await CardService.deleteSingleById(this.state.selectedCard.id));
		if (!res.ok) {
			this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
		}
		this.toast.show({ closable: false, detail: "Card has been deleted", life: 5000, severity: "warn", summary: "Card deleted!" });
		this.getCards(this.state.selectedItem.id);
		this.setState({ showDeleteCardModal: false });
	}

	async deleteGoalConfirm(rowData: any) {
		const res = await (await GoalService.deleteSingleById(this.state.selectedGoal.id));
		if (!res.ok) {
			this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
		}
		this.toast.show({ closable: false, detail: "Goal has been deleted", life: 5000, severity: "warn", summary: "Goal deleted!" });
		this.getGoals(this.state.selectedItem.id);
		this.setState({ showDeleteGoalModal: false });
	}

	async deleteItemConfirm(rowData: any) {
		const res = await (await FixtureService.deleteSingleById(this.state.selectedItem.id));
		if (!res.ok) {
			this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
		}
		this.toast.show({ closable: false, detail: "Your fixture has been deleted", life: 5000, severity: "warn", summary: "Fixture deleted!" });
		this.getItems();
		this.setState({ showDeleteModal: false });
	}

	async deleteSubConfirm(rowData: any) {
		const res = await (await SubstituteService.deleteSingleById(this.state.selectedSub.id));
		if (!res.ok) {
			this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
		}
		this.toast.show({ closable: false, detail: "Substitution has been deleted", life: 5000, severity: "warn", summary: "Substitution deleted!" });
		this.getSubstitutions(this.state.selectedItem.id);
		this.setState({ showDeleteSubModal: false });
	}

	deleteSelectedItemConfirm() { }

	itemInfoFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-download" label="Export Teamsheet" style={{ float: "left" }} onClick={() => this.exportTeamsheet()}></Button>
				<Button className="p-button-text" icon="pi pi-times" label="Cancel" onClick={() => this.setState({ selectedItem: new Fixture(), showItemInfoModal: false })}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Save" onClick={() => this.saveItem()}></Button>
			</>
		);
	}

	formatDate(value: any) {
		return new Date(value.fixtureDateTime).toLocaleDateString('en-GB', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
		});
	}

	globalFilterChange(e: any) {
		let value = ""
		if (e !== "") {
			value = e.target.value;
			let newData = this.state.masterItems.filter(function (item) {
				return item.team?.teamName?.toLowerCase().includes(value.toLowerCase());
			});
			this.setState({ items: newData });
		} else this.setState({ items: this.state.masterItems });
		this.setState({ globalFilter: value });
	}

	formatTeamsheetDate(date: Date) {
		const ordinal = (n: number) => n + (n % 10 === 1 && n % 100 !== 11 ? "st" : n % 10 === 2 && n % 100 !== 12 ? "nd" : n % 10 === 3 && n % 100 !== 13 ? "rd" : "th");
		const weekday = date.toLocaleDateString("en-GB", { weekday: "long" });
		const month = date.toLocaleDateString("en-GB", { month: "long" });
		let hours = date.getHours(); const mins = date.getMinutes();
		const ampm = hours >= 12 ? "pm" : "am";
		hours = hours % 12 || 12;
		return `${weekday}, ${month} ${ordinal(date.getDate())}, ${date.getFullYear()} - ${hours}.${String(mins).padStart(2, "0")}${ampm} kick-off`;
	}

	loadTeamsheetImage(src: string): Promise<HTMLImageElement | null> {
		const load = (url: string, cors: boolean): Promise<HTMLImageElement | null> => new Promise((resolve) => {
			const img = new Image();
			if (cors) img.crossOrigin = "anonymous";
			img.onload = () => resolve(img);
			img.onerror = () => resolve(null);
			img.src = url;
		});
		return load(src, true).then(async (direct) => {
			if (direct) return direct;
			try {
				const res = await FileService.proxyImage(src);
				if (!res.ok) return null;
				return load(URL.createObjectURL(await res.blob()), false);
			} catch { return null; }
		});
	}

	async exportTeamsheet() {
		const fixture = this.state.selectedItem;
		const W = 1240, H = 1754;
		const canvas = document.createElement("canvas");
		canvas.width = W; canvas.height = H;
		const ctx = canvas.getContext("2d");
		if (!ctx) return;
		const SERIF = "Georgia, 'Times New Roman', serif";
		let clubSettings: { [label: string]: string } = {};
		try { clubSettings = await ClubSettingService.getMap(); } catch { /* defaults */ }
		const CLARET = clubSettings[CLUB_SETTING_PRIMARY_COLOUR] || "#A83249";
		const clubName = clubSettings[CLUB_SETTING_NAME] || "Scunthorpe United";

		ctx.fillStyle = "#FFFFFF"; ctx.fillRect(0, 0, W, H);
		ctx.fillStyle = "#000000";

		// Date line with the league image beside it (as on the printed sheet)
		ctx.textAlign = "center";
		ctx.font = `24px ${SERIF}`;
		const dateText = this.formatTeamsheetDate(new Date(fixture.fixtureDateTime));
		const leagueLogo = clubSettings[CLUB_SETTING_LEAGUE_IMAGE] ? await this.loadTeamsheetImage(clubSettings[CLUB_SETTING_LEAGUE_IMAGE]) : null;
		if (leagueLogo) {
			const logoH = 48, logoW = logoH * (leagueLogo.width / leagueLogo.height);
			const groupW = ctx.measureText(dateText).width + 22 + logoW;
			const groupX = W / 2 - groupW / 2;
			ctx.textAlign = "left";
			ctx.fillText(dateText, groupX, 130);
			ctx.drawImage(leagueLogo, groupX + ctx.measureText(dateText).width + 22, 130 - 36, logoW, logoH);
			ctx.textAlign = "center";
		} else {
			ctx.fillText(dateText, W / 2, 130);
		}

		const awayTeamName = fixture.team?.teamName || this.state.teams.find((t) => t.id === fixture.teamId)?.teamName || "Visitors";
		const homePlayers = Array.isArray(this.state.homePlayers) ? this.state.homePlayers : [];
		const awayPlayers = Array.isArray(this.state.awayPlayers) ? this.state.awayPlayers : [];
		const homeManager = homePlayers.find((x) => Number(x.playerNumber) === 0);
		const awayManager = awayPlayers.find((x) => Number(x.playerNumber) === 0);
		const byNumber = (a: Player, b: Player) => a.playerNumber - b.playerNumber;
		const homeXI = homePlayers.filter((x) => x.playerStatus === 0 && Number(x.playerNumber) !== 0).sort(byNumber);
		const homeSubs = homePlayers.filter((x) => x.playerStatus === 10 && Number(x.playerNumber) !== 0).sort(byNumber);
		const awayXI = awayPlayers.filter((x) => x.playerStatus === 0 && Number(x.playerNumber) !== 0).sort(byNumber);
		const awaySubs = awayPlayers.filter((x) => x.playerStatus === 10 && Number(x.playerNumber) !== 0).sort(byNumber);

		const cols = [
			{ x0: 70, x1: 570, teamName: clubName, manager: homeManager, xi: homeXI, subs: homeSubs, sponsors: true },
			{ x0: 670, x1: 1170, teamName: awayTeamName, manager: awayManager, xi: awayXI, subs: awaySubs, sponsors: false }
		];

		const drawName = (player: Player, x: number, y: number, size: number) => {
			const parts = (player.playerName || "").trim().split(" ");
			const surname = parts.length > 1 ? parts.pop() : "";
			const first = parts.join(" ");
			ctx.textAlign = "left";
			ctx.font = `${size}px ${SERIF}`;
			let cursor = x;
			if (first) { ctx.fillText(first + " ", cursor, y); cursor += ctx.measureText(first + " ").width; }
			ctx.font = `bold ${size}px ${SERIF}`;
			ctx.fillText(surname || first, cursor, y);
		};

		for (const col of cols) {
			const centre = (col.x0 + col.x1) / 2;
			// Team name (wrap on two lines when long)
			ctx.fillStyle = "#000000"; ctx.textAlign = "center";
			ctx.font = `bold 44px ${SERIF}`;
			const words = col.teamName.split(" ");
			if (ctx.measureText(col.teamName).width > (col.x1 - col.x0) && words.length > 1) {
				const half = Math.ceil(words.length / 2);
				ctx.fillText(words.slice(0, half).join(" "), centre, 210);
				ctx.fillText(words.slice(half).join(" "), centre, 258);
			} else {
				ctx.fillText(col.teamName, centre, 234);
			}
			// Manager
			if (col.manager) {
				ctx.font = `bold 26px ${SERIF}`;
				ctx.fillText(`Manager: ${col.manager.playerName}`, centre, 306);
				if (col.manager.sponsorText) {
					ctx.font = `italic 16px ${SERIF}`;
					ctx.fillText(`sponsored by ${col.manager.sponsorText}`, centre, 328);
				}
			}
			// Claret rule
			ctx.fillStyle = CLARET;
			ctx.fillRect(col.x0, 344, col.x1 - col.x0, 9);
			ctx.fillStyle = "#000000";

			// Starting line-up
			ctx.textAlign = "left";
			ctx.font = `bold 27px ${SERIF}`;
			ctx.fillText("Starting line-up:", col.x0, 398);
			let y = 440;
			const pitch = col.sponsors ? 47 : 31;
			for (const player of col.xi) {
				ctx.textAlign = "right"; ctx.font = `bold 24px ${SERIF}`;
				ctx.fillText(String(player.playerNumber), col.x0 + 45, y);
				drawName(player, col.x0 + 72, y, 24);
				if (col.sponsors && player.sponsorText) {
					ctx.textAlign = "left"; ctx.font = `italic 15px ${SERIF}`;
					ctx.fillText(`sponsored by ${player.sponsorText}`, col.x0 + 72, y + 19);
				}
				y += pitch;
			}
			// Substitutes
			y += 28;
			ctx.textAlign = "left"; ctx.font = `bold 27px ${SERIF}`;
			ctx.fillText("Substitutes:", col.x0, y);
			y += 42;
			for (const player of col.subs) {
				ctx.textAlign = "right"; ctx.font = `bold 24px ${SERIF}`;
				ctx.fillText(String(player.playerNumber), col.x0 + 45, y);
				drawName(player, col.x0 + 72, y, 24);
				if (col.sponsors && player.sponsorText) {
					ctx.textAlign = "left"; ctx.font = `italic 15px ${SERIF}`;
					ctx.fillText(`sponsored by ${player.sponsorText}`, col.x0 + 72, y + 19);
				}
				y += pitch;
			}
		}

		// Match officials (right column, lower area)
		const officials = [
			{ name: fixture.referee, icon: "whistle" },
			{ name: fixture.linesmanOne, icon: "flag" },
			{ name: fixture.linesmanTwo, icon: "flag" },
			{ name: fixture.fourthOfficial, icon: "board" }
		].filter((o) => o.name);
		if (officials.length > 0) {
			let oy = 1330;
			ctx.textAlign = "left";
			ctx.font = `bold 24px ${SERIF}`;
			ctx.fillText("Match Officials", 800, oy);
			oy += 44;
			for (const official of officials) {
				if (official.icon === "whistle") {
					ctx.fillStyle = "#000000";
					ctx.beginPath(); ctx.arc(770, oy - 8, 13, 0, Math.PI * 2); ctx.fill();
					ctx.fillStyle = "#FFFFFF";
					ctx.beginPath(); ctx.arc(766, oy - 12, 4, 0, Math.PI * 2); ctx.fill();
				} else if (official.icon === "flag") {
					ctx.fillStyle = "#E6B800";
					ctx.beginPath(); ctx.moveTo(760, oy - 22); ctx.lineTo(784, oy - 14); ctx.lineTo(760, oy - 6); ctx.closePath(); ctx.fill();
					ctx.fillStyle = "#C62828";
					ctx.beginPath(); ctx.moveTo(760, oy - 22); ctx.lineTo(772, oy - 18); ctx.lineTo(760, oy - 14); ctx.closePath(); ctx.fill();
					ctx.strokeStyle = "#000000"; ctx.lineWidth = 2;
					ctx.beginPath(); ctx.moveTo(760, oy - 24); ctx.lineTo(760, oy + 2); ctx.stroke();
				} else {
					ctx.fillStyle = "#111111";
					ctx.fillRect(756, oy - 22, 34, 22);
					ctx.fillStyle = "#E53935"; ctx.font = "bold 13px Arial";
					ctx.textAlign = "left"; ctx.fillText("9", 762, oy - 6);
					ctx.fillStyle = "#43A047"; ctx.fillText("10", 774, oy - 6);
				}
				ctx.fillStyle = "#000000";
				ctx.textAlign = "left"; ctx.font = `24px ${SERIF}`;
				ctx.fillText(official.name, 806, oy);
				oy += 44;
			}
		}

		// Teamsheet sponsor footer: configured logo first, match sponsor name as fallback
		ctx.textAlign = "center";
		ctx.font = `italic 22px ${SERIF}`;
		ctx.fillStyle = "#000000";
		ctx.fillText("Official Teamsheet Sponsors", 920, 1600);
		let sponsorDrawn = false;
		try {
			const sponsorImageUrl = clubSettings[CLUB_SETTING_TEAMSHEET_SPONSOR_IMAGE];
			if (sponsorImageUrl) {
				const logo = await this.loadTeamsheetImage(sponsorImageUrl);
				if (logo) {
					const maxW = 620, maxH = 96;
					const scale = Math.min(maxW / logo.width, maxH / logo.height);
					const w = logo.width * scale, h = logo.height * scale;
					ctx.drawImage(logo, 920 - w / 2, 1622 + (maxH - h) / 2, w, h);
					sponsorDrawn = true;
				}
			}
		} catch { /* fall back to text */ }
		if (!sponsorDrawn) {
			const matchSponsor = this.state.sponsors.find((x) => x.id === fixture.matchSponsorId);
			if (matchSponsor) {
				const sponsorName = matchSponsor.name.toUpperCase();
				let fontSize = 26;
				ctx.font = `bold ${fontSize}px ${SERIF}`;
				while (ctx.measureText(sponsorName).width > 480 && fontSize > 16) {
					fontSize -= 2;
					ctx.font = `bold ${fontSize}px ${SERIF}`;
				}
				const boxWidth = Math.max(340, ctx.measureText(sponsorName).width + 60);
				ctx.fillStyle = "#111111";
				ctx.fillRect(920 - boxWidth / 2, 1622, boxWidth, 64);
				ctx.fillStyle = "#D4A017";
				ctx.fillText(sponsorName, 920, 1662);
			}
		}

		// A4 PDF download (same 1240x1754 layout = A4 @150dpi)
		const pdf = CanvasToA4Pdf(canvas);
		const link = document.createElement("a");
		link.href = URL.createObjectURL(pdf);
		const d = new Date(fixture.fixtureDateTime);
		link.download = `teamsheet-${d.toISOString().slice(0, 10)}-${(fixture.team?.teamNameShort || "fixture").toLowerCase().replace(/\s+/g, "-")}.pdf`;
		link.click();
		URL.revokeObjectURL(link.href);
	}

	async getAwayPlayers(rowData: any) {
		this.setState({ isLoading: true });
		const res = await safeJson(PlayerService.getByTeam(rowData.teamId));
		if (res && res.error) {
			this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
			this.setState({ isLoading: false });
		}
		this.setState({ isLoading: false, awayPlayers: res });
	}

	async getCards(id: any) {
		this.setState({ isLoading: true });
		const res = await safeJson(CardService.getByFixture(id));
		if (res && res.error) {
			this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
			this.setState({ isLoading: false });
		}
		this.setState({ isLoading: false, cards: res });
	}

	async getGoals(id: any) {
		this.setState({ isLoading: true });
		const res = await safeJson(GoalService.getByFixture(id));
		if (res && res.error) {
			this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
			this.setState({ isLoading: false });
		}
		this.setState({ isLoading: false, goals: res });
	}

	async getSubstitutions(id: any) {
		this.setState({ isLoading: true });
		const res = await safeJson(SubstituteService.getByFixture(id));
		if (res && res.error) {
			this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
			this.setState({ isLoading: false });
		}
		this.setState({ isLoading: false, substitutes: res });
	}

	async getItems() {
		this.setState({ isLoading: true });
		const res = await safeJson(FixtureService.getFixtures());
		if (res && res.error) {
			this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
			this.setState({ isLoading: false });
		}
		// Opened from the setState callback, not after it. setState is
		// asynchronous, so calling openFixtureById on the next line searched the
		// PREVIOUS items — an empty array on first load — found nothing, and
		// left the embedded editor on "Loading matchday…" for ever. The parent
		// remounts this component per fixture (key={md-<id>}), so this mount
		// path is the only one that runs and nothing else covered it.
		this.setState({ isLoading: false, items: res, masterItems: res }, () => {
			if (this.props.embedded && this.props.fixtureId) this.openFixtureById(this.props.fixtureId);
		});
	}

	/**
	 * Competitions for the fixture dropdown. Failure is silent on purpose: the
	 * endpoint ships alongside season tickets, and a fixture form that won't
	 * open because competitions are unavailable would be a bad trade.
	 */
	async getCompetitions() {
		try {
			const res = await safeJson(CompetitionService.getAll());
			this.setState({ competitions: Array.isArray(res) ? res : [] });
		} catch {
			this.setState({ competitions: [] });
		}
	}

	/**
	 * Seasons for the fixture dropdown. Silent on failure for the same reason
	 * as competitions: a fixture form that won't open is worse than one missing
	 * a dropdown.
	 */
	async getSeasons() {
		try {
			const res = await safeJson(SeasonService.getAll());
			this.setState({ seasons: Array.isArray(res) ? res : [] });
		} catch {
			this.setState({ seasons: [] });
		}
	}

	async getTeams() {
		this.setState({ isLoading: true });
		const res = await safeJson(TeamService.getAll());
		if (res && res.error) {
			this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
			this.setState({ isLoading: false });
		}
		this.setState({ isLoading: false, teams: res });
	}

	async getHomePlayers() {
		this.setState({ isLoading: true });
		const res = await safeJson(PlayerService.getHomeTeam());
		if (res && res.error) {
			this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
			this.setState({ isLoading: false });
		}
		this.setState({ isLoading: false, homePlayers: res });
	}

	async getSponsors() {
		this.setState({ isLoading: true });
		const res = await safeJson(SponsorService.getAll());
		if (res && res.error) {
			this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
			this.setState({ isLoading: false });
		}
		this.setState({ isLoading: false, sponsors: res });
	}

	inputChange(e: any, name: string) {
		const val = (e.target && e.target.value) || "";
		let selectedItem = new Fixture({ ...this.state.selectedItem });
		// @ts-ignore // Required to be able to use a generic function to change the values
		selectedItem[name] = val;
		this.setState({ selectedItem });
	}

	inputNumberChange(e: any, name: string) {
		const val = e.value || 0;
		let selectedItem = new Fixture({ ...this.state.selectedItem });
		// @ts-ignore // Required to be able to use a generic function to change the values
		selectedItem[name] = val;
		this.setState({ selectedItem });
	}

	openItemModal(rowData: any) {
		this.getGoals(rowData.id);
		this.getAwayPlayers(rowData);
		this.getSubstitutions(rowData.id);
		this.getCards(rowData.id);
		this.setState({ selectedItem: rowData, showItemInfoModal: true })
	}

	render() {
		// Embedded in the merged Fixtures screen: the editor and its
		// confirmations only. The parent owns the calendar, list and toolbar.
		if (this.props.embedded) {
			if (!this.state.selectedItem?.id || this.state.selectedItem.id < 1) {
				return <div style={{ color: "var(--pb-text-muted)", padding: 16 }}>Loading matchday&hellip;</div>;
			}
			return (
				<div className="matchday-embedded">
					{this.renderMatchdayTabs()}
					<div className="matchday-actions">
						<Button className="p-button-text" icon="pi pi-download" label="Export teamsheet" onClick={() => this.exportTeamsheet()} />
						<Button icon="pi pi-check" label="Save matchday" onClick={() => this.saveItem()} />
					</div>
					{this.renderConfirmDialogs()}
					<Toast ref={(el) => this.toast = el}></Toast>
				</div>
			);
		}

		return (
			<>
				<Row>
					<Col>
						<div className="card" style={{ paddingTop: "1.5rem" }}>
							<h5 style={{ paddingBottom: "1rem", paddingLeft: "1.5rem" }}>{this.itemNamePlural}</h5>
							<Toolbar left={() => this.renderLeftToolbarButtons()} right={() => this.renderRightToolbarButtons()}></Toolbar>
							{this.state.viewMode === "calendar" && this.renderCalendar()}
							{this.state.viewMode === "list" &&
							<DataTable loading={this.state.isLoading} onSelectionChange={(e) => this.setState({ selectedItems: e.value })} ref={(el) => this.dt = el} scrollable scrollHeight="flex" selection={this.state.selectedItems} style={{ height: "calc(100vh - 17.5rem)" }} value={this.state.items} sortField="fixtureDateTime" sortOrder={-1}>
								{/* <Column headerStyle={{width: 50}} selectionMode="multiple"></Column> */}
								<Column field="fixtureDateTime" body={(rowData) => this.formatDate(rowData)} header="Matchday" sortable ></Column>
								<Column field="team.teamNameShort" header="Team Name" sortable ></Column>
								<Column style={{ width: 75 }} body={(rowData) => (
									<div className="actions">
										<Button onClick={() => this.openItemModal(rowData)} style={{ backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30 }}>
											<FontAwesomeIcon icon={faPencil} style={{ color: colours.white }} />
										</Button>
										{new Date(rowData.fixtureDateTime) > new Date() &&
											<Button onClick={() => this.setState({ selectedItem: rowData, showDeleteModal: true })} style={{ backgroundColor: colours.error, borderColor: colours.error, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30 }}>
												<FontAwesomeIcon icon={faTrash} style={{ color: colours.white }} />
											</Button>
										}
									</div>
								)}></Column>
							</DataTable>
							}
							<Dialog className="p-fluid" footer={() => this.itemInfoFooter()} header={this.itemName + " Details"} modal onHide={() => this.setState({ showItemInfoModal: false })} style={{ width: "75%", height: "80%" }} visible={this.state.showItemInfoModal}>
								{this.renderMatchdayTabs()}
							</Dialog>
						</div>
					</Col>
				</Row>
				{this.renderConfirmDialogs()}
				<Toast ref={(el) => this.toast = el}></Toast>
				{this.state.showPlayers && (
					<Navigate replace={true} to={`/${environment.build.adminRoute}/Fixture-homePlayers/${this.state.selectedItem.id}`} />
				)}
			</>
		);
	}


	/**
	 * The matchday editor itself.
	 *
	 * Extracted so the merged Fixtures screen can embed it rather than
	 * duplicating it — two copies of a form this size drift apart within a
	 * season.
	 */
	renderMatchdayTabs() {
		return (
								<TabView className="tabview-header-icon">
				<TabPanel header="Basic Information" leftIcon="pi pi-info-circle">
					<Row>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="fixtureDateTime">Matchday <span style={{ color: "red" }}>*</span></label>
								<Calendar id="fixtureDateTime" onChange={(e) => this.inputChange(e, "fixtureDateTime")} required value={new Date(this.state.selectedItem.fixtureDateTime)} showTime showButtonBar />
							</div>
						</Col>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="teamId">Visitor <span style={{ color: "red" }}>*</span></label>
								<Dropdown id="teamId" onChange={(e: any) => this.setState({ selectedItem: { ...this.state.selectedItem, teamId: e.value } })} options={this.state.teams} optionLabel="teamName" optionValue="id" style={{ width: "100%" }} value={this.state.selectedItem.teamId} />
							</div>
						</Col>
					</Row>
					<Row>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="competitionId">Competition</label>
								<Dropdown id="competitionId" onChange={(e: any) => this.setState({ selectedItem: { ...this.state.selectedItem, competitionId: e.value } })} options={this.state.competitions} optionLabel="name" optionValue="id" placeholder="Not set" showClear style={{ width: "100%" }} value={this.state.selectedItem.competitionId} />
								<small style={{ color: "var(--pb-text-muted)" }}>Season tickets only admit holders to fixtures in a competition they cover.</small>
							</div>
						</Col>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="seasonId">Season</label>
								<Dropdown id="seasonId" onChange={(e: any) => this.setState({ selectedItem: { ...this.state.selectedItem, seasonId: e.value } })} options={this.state.seasons} optionLabel="name" optionValue="id" placeholder="Not set" showClear style={{ width: "100%" }} value={this.state.selectedItem.seasonId} />
								<small style={{ color: "var(--pb-text-muted)" }}>Which season this counts towards. Pre-season friendlies belong to the season about to start, even though they fall outside its dates.</small>
							</div>
						</Col>
					</Row>
					<Row>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="homeScore">Home Score</label>
								<InputText id="homeScore" value={this.state.selectedItem.homeScore} onChange={(e) => this.inputChange(e, "homeScore")} />
							</div>
						</Col>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="awayScore">Away Score</label>
								<InputText id="awayScore" value={this.state.selectedItem.awayScore} onChange={(e) => this.inputChange(e, "awayScore")} />
							</div>
						</Col>
					</Row>
					<Row>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="firstHalfAdditional">First Half Additional</label>
								<InputText id="firstHalfAdditional" value={this.state.selectedItem.firstHalfAdditional} onChange={(e) => this.inputChange(e, "firstHalfAdditional")} />
							</div>
						</Col>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="secondHalfAdditional">Second Half Additional</label>
								<InputText id="secondHalfAdditional" value={this.state.selectedItem.secondHalfAdditional} onChange={(e) => this.inputChange(e, "secondHalfAdditional")} />
							</div>
						</Col>
					</Row>
					<Row>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="minutesPerHalf">Minutes Per Half</label>
								<InputText id="minutesPerHalf" keyfilter="pint" placeholder="45" value={this.state.selectedItem.minutesPerHalf ?? ""} onChange={(e) => this.inputChange(e, "minutesPerHalf")} />
							</div>
						</Col>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="penaltyShots">Penalty Shots (each team)</label>
								<InputText id="penaltyShots" keyfilter="pint" placeholder="5" value={this.state.selectedItem.penaltyShots ?? ""} onChange={(e) => this.inputChange(e, "penaltyShots")} />
							</div>
						</Col>
					</Row>
					<Row>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="manOfTheMatchId">Man of the Match</label>
								<Dropdown id="manOfTheMatchId" onChange={(e: any) => this.setState({ selectedItem: { ...this.state.selectedItem, manOfTheMatchId: e.value } })} options={this.state.homePlayers} optionLabel="playerName" optionValue="id" style={{ width: "100%" }} value={this.state.selectedItem.manOfTheMatchId} />
							</div>
						</Col>
					</Row>
				</TabPanel>
				<TabPanel header="Attendance" leftIcon="pi pi-users">
					<Row>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="matchAttendance">Attendance</label>
								<InputText id="matchAttendance" value={this.state.selectedItem.matchAttendance} onChange={(e) => this.inputChange(e, "matchAttendance")} />
							</div>
						</Col>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="matchAwayAttendance">Away Attendance</label>
								<InputText id="matchAwayAttendance" value={this.state.selectedItem.matchAwayAttendance} onChange={(e) => this.inputChange(e, "matchAwayAttendance")} />
							</div>
						</Col>
					</Row>
				</TabPanel>
				<TabPanel header="Half Time Draw" leftIcon="pi pi-ticket">
					<Row>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="htDrawFirst">First Place Number</label>
								<InputText id="htDrawFirst" value={this.state.selectedItem.htDrawFirst} onChange={(e) => this.inputChange(e, "htDrawFirst")} />
							</div>
						</Col>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="htDrawFirstPrize">First Place Prize</label>
								<InputNumber id="htDrawFirstPrize" value={this.state.selectedItem.htDrawFirstPrize} onValueChange={(e) => this.inputNumberChange(e, "htDrawFirstPrize")} />
							</div>
						</Col>
					</Row>
					<Row>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="htDrawSecond">Second Place Number</label>
								<InputText id="htDrawSecond" value={this.state.selectedItem.htDrawSecond} onChange={(e) => this.inputChange(e, "htDrawSecond")} />
							</div>
						</Col>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="htDrawSecondPrize">Second Place Prize</label>
								<InputNumber id="htDrawSecondPrize" value={this.state.selectedItem.htDrawSecondPrize} onValueChange={(e) => this.inputNumberChange(e, "htDrawSecondPrize")} />
							</div>
						</Col>
					</Row>
					<Row>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="htDrawThird">Third Place Number</label>
								<InputText id="htDrawThird" value={this.state.selectedItem.htDrawThird} onChange={(e) => this.inputChange(e, "htDrawThird")} />
							</div>
						</Col>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="htDrawThirdPrize">Third Place Prize</label>
								<InputNumber id="htDrawThirdPrize" value={this.state.selectedItem.htDrawThirdPrize} onValueChange={(e) => this.inputNumberChange(e, "htDrawThirdPrize")} />
							</div>
						</Col>
					</Row>
					<Row>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="htDrawSponsorId">Draw Sponsor</label>
								<Dropdown id="htDrawSponsorId" onChange={(e: any) => this.setState({ selectedItem: { ...this.state.selectedItem, htDrawSponsorId: e.value } })} options={this.state.sponsors} optionLabel="name" optionValue="id" placeholder="No sponsor" showClear style={{ width: "100%" }} value={this.state.selectedItem.htDrawSponsorId} />
								{/* Recording who backs the draw and putting them on the
								    board are separate decisions, so the tick is separate
								    from the dropdown. */}
								<div style={{ alignItems: "center", display: "flex", gap: 10, marginTop: 12 }}>
									<InputSwitch checked={!!this.state.selectedItem.htDrawShowSponsor} onChange={(e: any) => this.setState({ selectedItem: { ...this.state.selectedItem, htDrawShowSponsor: e.value } })} />
									<label htmlFor="htDrawShowSponsor" style={{ margin: 0 }}>Show them on the draw board</label>
								</div>
								<small style={{ color: "#9DA3AF", display: "block", marginTop: 6 }}>Off, or with no sponsor picked, the bar doesn&rsquo;t appear at all.</small>
							</div>
						</Col>
						<Col />
					</Row>
				</TabPanel>
				<TabPanel header="Sponsors" leftIcon="pi pi-dollar">
					<Row>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="matchSponsorId">Match Sponsor</label>
								<Dropdown id="matchSponsorId" onChange={(e: any) => this.setState({ selectedItem: { ...this.state.selectedItem, matchSponsorId: e.value } })} options={this.state.sponsors} optionLabel="name" optionValue="id" style={{ width: "100%" }} value={this.state.selectedItem.matchSponsorId} />
							</div>
						</Col>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="matchballSponsorId">Matchball Sponsor</label>
								<Dropdown id="matchballSponsorId" onChange={(e: any) => this.setState({ selectedItem: { ...this.state.selectedItem, matchballSponsorId: e.value } })} options={this.state.sponsors} optionLabel="name" optionValue="id" style={{ width: "100%" }} value={this.state.selectedItem.matchballSponsorId} />
							</div>
						</Col>
					</Row>
					<Row>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="programmeSponsorId">Programme Sponsor</label>
								<Dropdown id="programmeSponsorId" onChange={(e: any) => this.setState({ selectedItem: { ...this.state.selectedItem, programmeSponsorId: e.value } })} options={this.state.sponsors} optionLabel="name" optionValue="id" style={{ width: "100%" }} value={this.state.selectedItem.programmeSponsorId} />
							</div>
						</Col>
						<Col>
							<div className="field" style={{ marginBottom: 10 }}>
								<label htmlFor="captainSponsorId">Captain Sponsor</label>
								<Dropdown id="captainSponsorId" onChange={(e: any) => this.setState({ selectedItem: { ...this.state.selectedItem, captainSponsorId: e.value } })} options={this.state.sponsors} optionLabel="name" optionValue="id" style={{ width: "100%" }} value={this.state.selectedItem.captainSponsorId} />
							</div>
						</Col>
					</Row>
				</TabPanel>
				<TabPanel header="Goals" leftIcon="pi pi-star">
					<Row>
						<Col>
							<Row>
								<div className="field" style={{ marginBottom: 10 }}>
									<label htmlFor="homeScorer">Home Scorer</label>
									<Dropdown id="homeScorer" onChange={(e: any) => this.setState({ homeScorerId: e.value })} options={this.state.homePlayers.filter(x => x.playerStatus === 0)} optionLabel="playerName" optionValue="id" style={{ width: "100%" }} value={this.state.homeScorerId} />
								</div>
							</Row>
							<Row>
								<Button icon="pi pi-add" label="CREATE HOME GOAL" style={{ backgroundColor: colours.success, borderColor: colours.success, width: "97%", marginLeft: 10 }} onClick={() => this.createGoal(true)}></Button>
							</Row>
						</Col>
						<Col>
							<Row>
								<div className="field" style={{ marginBottom: 10 }}>
									<label htmlFor="matchballSponsorId">Away Scorer</label>
									<Dropdown id="matchballSponsorId" onChange={(e: any) => this.setState({ awayScorerId: e.value })} options={this.state.awayPlayers.filter(x => x.playerStatus === 0)} optionLabel="playerName" optionValue="id" style={{ width: "100%" }} value={this.state.awayScorerId} />
								</div>
							</Row>
							<Row>
								<Button icon="pi pi-add" label="CREATE AWAY GOAL" style={{ backgroundColor: colours.error, borderColor: colours.error, width: "97%", marginLeft: 10 }} onClick={() => this.createGoal(false)}></Button>
							</Row>
						</Col>
					</Row>
					<br />
					<Row>
						<Col>
							<DataTable id="goals" scrollable scrollHeight="350px" style={{ marginBottom: 10 }} value={this.state.goals}>
								<Column field="createdAt" header="Goal Date Time" sortable></Column>
								<Column field="player.team.teamNameShort" header="Team" sortable></Column>
								<Column field="player.playerName" header="Player Name" sortable></Column>
								<Column field="player.playerNumber" header="Player Number" sortable></Column>
								<Column style={{ width: 75 }} body={(rowData) => (
									<div className="actions">
										<Button onClick={() => this.setState({ selectedGoal: rowData, showDeleteGoalModal: true })} style={{ backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30 }}>
											<FontAwesomeIcon icon={faTrash} style={{ color: colours.white }} />
										</Button>
									</div>
								)}></Column>
							</DataTable>
						</Col>
					</Row>
				</TabPanel>
				<TabPanel header="Substitutes" leftIcon="pi pi-user-minus">
					<Row>
						<Col>
							<Row>
								<Col>
									<div className="field" style={{ marginBottom: 10 }}>
										<label htmlFor="homePlayerOnId">Home ON</label>
										<Dropdown id="homePlayerOnId" onChange={(e: any) => this.setState({ homePlayerOnId: e.value })} options={this.state.homePlayers.filter(x => x.playerStatus === 10)} optionLabel="playerName" optionValue="id" style={{ width: "100%" }} value={this.state.homePlayerOnId} />
									</div>
								</Col>
								<Col>
									<div className="field" style={{ marginBottom: 10 }}>
										<label htmlFor="homePlayerOffId">Home OFF</label>
										<Dropdown id="homePlayerOffId" onChange={(e: any) => this.setState({ homePlayerOffId: e.value })} options={this.state.homePlayers.filter(x => x.playerStatus === 0)} optionLabel="playerName" optionValue="id" style={{ width: "100%" }} value={this.state.homePlayerOffId} />
									</div>
								</Col>
							</Row>
							<Row>
								<Button icon="pi pi-add" label="CREATE HOME SUBSTITUTION" style={{ backgroundColor: colours.success, borderColor: colours.success, width: "97%", marginLeft: 10 }} onClick={() => this.createSubstitute(true)}></Button>
							</Row>
						</Col>
						<Col>
							<Row>
								<Col>
									<div className="field" style={{ marginBottom: 10 }}>
										<label htmlFor="awayPlayerOnId">Away ON</label>
										<Dropdown id="awayPlayerOnId" onChange={(e: any) => this.setState({ awayPlayerOnId: e.value })} options={this.state.awayPlayers.filter(x => x.playerStatus === 10)} optionLabel="playerName" optionValue="id" style={{ width: "100%" }} value={this.state.awayPlayerOnId} />
									</div>
								</Col>
								<Col>
									<div className="field" style={{ marginBottom: 10 }}>
										<label htmlFor="awayPlayerOffId">Away OFF</label>
										<Dropdown id="awayPlayerOffId" onChange={(e: any) => this.setState({ awayPlayerOffId: e.value })} options={this.state.awayPlayers.filter(x => x.playerStatus === 0)} optionLabel="playerName" optionValue="id" style={{ width: "100%" }} value={this.state.awayPlayerOffId} />
									</div>
								</Col>
							</Row>
							<Row>
								<Button icon="pi pi-add" label="CREATE AWAY SUBSTITUTION" style={{ backgroundColor: colours.error, borderColor: colours.error, width: "97%", marginLeft: 10 }} onClick={() => this.createSubstitute(false)}></Button>
							</Row>
						</Col>
					</Row>
					<Row>
						<Col>
							<DataTable id="subs" scrollable scrollHeight="350px" style={{ marginBottom: 10 }} value={this.state.substitutes}>
								<Column field="createdAt" header="Sub Date Time" sortable></Column>
								<Column field="playerOn.team.teamNameShort" header="Team" sortable></Column>
								<Column field="playerOn.playerName" header="Player On Name" sortable></Column>
								<Column field="playerOn.playerNumber" header="Player On Number" sortable></Column>
								<Column field="playerOff.playerName" header="Player Off Name" sortable></Column>
								<Column field="playerOff.playerNumber" header="Player Off Number" sortable></Column>
								<Column style={{ width: 75 }} body={(rowData) => (
									<div className="actions">
										<Button onClick={() => this.setState({ selectedSub: rowData, showDeleteSubModal: true })} style={{ backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30 }}>
											<FontAwesomeIcon icon={faTrash} style={{ color: colours.white }} />
										</Button>
									</div>
								)}></Column>
							</DataTable>
						</Col>
					</Row>
				</TabPanel>
				<TabPanel header="Cards" leftIcon="pi pi-exclamation-triangle">
					<Row>
						<Col>
							<Row>
								<div className="field" style={{ marginBottom: 10 }}>
									<label htmlFor="homePlayerCardId">Home Offender</label>
									<Dropdown id="homePlayerCardId" onChange={(e: any) => this.setState({ homePlayerCardId: e.value })} options={this.state.homePlayers.filter(x => x.playerStatus === 0)} optionLabel="playerName" optionValue="id" style={{ width: "100%" }} value={this.state.homePlayerCardId} />
								</div>
							</Row>
							<Row>
								<Button icon="pi pi-add" label="YELLOW CARD" style={{ backgroundColor: colours.warning, borderColor: colours.warning, width: "48%", marginLeft: 10, color: colours.black }} onClick={() => this.createCard(true, true)}></Button>
								<Button icon="pi pi-add" label="RED CARD" style={{ backgroundColor: colours.error, borderColor: colours.error, width: "48%", marginLeft: 10 }} onClick={() => this.createCard(true,false)}></Button>
							</Row>
						</Col>
						<Col>
							<Row>
								<div className="field" style={{ marginBottom: 10 }}>
									<label htmlFor="awayPlayerCardId">Away Offender</label>
									<Dropdown id="awayPlayerCardId" onChange={(e: any) => this.setState({ awayPlayerCardId: e.value })} options={this.state.awayPlayers.filter(x => x.playerStatus === 0)} optionLabel="playerName" optionValue="id" style={{ width: "100%" }} value={this.state.awayPlayerCardId} />
								</div>
							</Row>
							<Row>
							<Button icon="pi pi-add" label="YELLOW CARD" style={{ backgroundColor: colours.warning, borderColor: colours.warning, width: "48%", marginLeft: 10, color: colours.black }} onClick={() => this.createCard(false,true)}></Button>
								<Button icon="pi pi-add" label="RED CARD" style={{ backgroundColor: colours.error, borderColor: colours.error, width: "48%", marginLeft: 10 }} onClick={() => this.createCard(false,false)}></Button>
							</Row>
						</Col>
					</Row>
					<br />
					<Row>
						<Col>
							<DataTable id="cards" scrollable scrollHeight="350px" style={{ marginBottom: 10 }} value={this.state.cards}>
								<Column field="createdAt" header="Card Date Time" sortable></Column>
								<Column field="cardType" header="Card Type" sortable body={(rowData: Card) => CardType[rowData.cardType].split(/(?=[A-Z])/).join(" ")}></Column>
								<Column field="player.team.teamNameShort" header="Team" sortable></Column>
								<Column field="player.playerName" header="Player Name" sortable></Column>
								<Column field="player.playerNumber" header="Player Number" sortable></Column>
								<Column style={{ width: 75 }} body={(rowData) => (
									<div className="actions">
										<Button onClick={() => this.setState({ selectedCard: rowData, showDeleteCardModal: true })} style={{ backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30 }}>
											<FontAwesomeIcon icon={faTrash} style={{ color: colours.white }} />
										</Button>
									</div>
								)}></Column>
							</DataTable>
						</Col>
					</Row>
				</TabPanel>
			</TabView>
		);
	}

	/** Delete confirmations, shared by the standalone and embedded views. */
	renderConfirmDialogs() {
		return (
			<>
				<Dialog footer={() => this.deleteItemFooter()} header="Confirm" modal onHide={() => this.setState({ showDeleteModal: false })} style={{ width: 550 }} visible={this.state.showDeleteModal}>
					<div className="d-flex align-items-center justify-content-center">
						<i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: "2rem", marginRight: "0.5rem" }} />
						{this.state.selectedItem &&
							<span>Are you sure you want to delete fixture against <b>{this.state.selectedItem.team?.teamName}</b>?</span>
						}
					</div>
				</Dialog>
				<Dialog footer={() => this.deleteCardFooter()} header="Confirm" modal onHide={() => this.setState({ showDeleteCardModal: false })} style={{ width: 550 }} visible={this.state.showDeleteCardModal}>
					<div className="d-flex align-items-center justify-content-center">
						<i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: "2rem", marginRight: "0.5rem" }} />
						{this.state.selectedItem &&
							<span>Are you sure you want to delete this goal for <b>{this.state.selectedCard.player?.playerName}</b>?</span>
						}
					</div>
				</Dialog>
				<Dialog footer={() => this.deleteGoalFooter()} header="Confirm" modal onHide={() => this.setState({ showDeleteGoalModal: false })} style={{ width: 550 }} visible={this.state.showDeleteGoalModal}>
					<div className="d-flex align-items-center justify-content-center">
						<i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: "2rem", marginRight: "0.5rem" }} />
						{this.state.selectedItem &&
							<span>Are you sure you want to delete this goal by <b>{this.state.selectedGoal.player?.playerName}</b>?</span>
						}
					</div>
				</Dialog>
				<Dialog footer={() => this.deleteSubFooter()} header="Confirm" modal onHide={() => this.setState({ showDeleteSubModal: false })} style={{ width: 550 }} visible={this.state.showDeleteSubModal}>
					<div className="d-flex align-items-center justify-content-center">
						<i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: "2rem", marginRight: "0.5rem" }} />
						{this.state.selectedItem &&
							<span>Are you sure you want to delete this <b>substitution</b>?</span>
						}
					</div>
				</Dialog>
			</>
		);
	}

	calendarNavigate(delta: number) {
		const m = this.state.calendarMonth;
		this.setState({ calendarMonth: new Date(m.getFullYear(), m.getMonth() + delta, 1) });
	}

	renderCalendar() {
		const monthStart = new Date(this.state.calendarMonth.getFullYear(), this.state.calendarMonth.getMonth(), 1);
		const offset = (monthStart.getDay() + 6) % 7; // Monday-first grid
		const cells = Array.from({ length: 42 }, (_, i) => new Date(monthStart.getFullYear(), monthStart.getMonth(), 1 - offset + i));
		const today = new Date().toDateString();

		return (
			<div className="fixture-calendar">
				<div className="cal-header">
					<Button className="p-button-outlined" icon="pi pi-chevron-left" onClick={() => this.calendarNavigate(-1)}></Button>
					<h5 className="cal-title">{monthStart.toLocaleDateString("en-GB", { month: "long", year: "numeric" })}</h5>
					<Button className="p-button-outlined" icon="pi pi-chevron-right" onClick={() => this.calendarNavigate(1)}></Button>
					<Button className="p-button-text" label="Today" onClick={() => this.setState({ calendarMonth: new Date() })}></Button>
				</div>
				<div className="cal-grid">
					{["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"].map((d) => <div className="cal-dow" key={`cal-dow-${d}`}>{d}</div>)}
					{cells.map((day, i) => {
						const dayFixtures = (Array.isArray(this.state.items) ? this.state.items : []).filter((x) => new Date(x.fixtureDateTime).toDateString() === day.toDateString());
						return (
							<div className={`cal-cell${day.getMonth() !== monthStart.getMonth() ? " outside" : ""}${day.toDateString() === today ? " today" : ""}`} key={`cal-cell-${i}`}>
								<div className="cal-day">{day.getDate()}</div>
								{dayFixtures.map((fixture, j) =>
									<div className="cal-fixture" key={`cal-fixture-${i}-${j}`} onClick={() => this.openItemModal(fixture)} title={`${fixture.team?.teamName || ""} - ${new Date(fixture.fixtureDateTime).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })} KO`}>
										{fixture.team?.badgeUrl && <img alt="" src={fixture.team.badgeUrl} />}
										<span>{new Date(fixture.fixtureDateTime).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })} {fixture.team?.teamNameShort || fixture.team?.teamName || "Fixture"}</span>
										{new Date(fixture.fixtureDateTime) > new Date() &&
											<span className="cal-fixture-delete" onClick={(e) => { e.stopPropagation(); this.setState({ selectedItem: fixture, showDeleteModal: true }); }} title="Delete fixture"><i className="pi pi-times" /></span>
										}
									</div>
								)}
							</div>
						);
					})}
				</div>
			</div>
		);
	}

	renderLeftToolbarButtons() {
		return (
			<>
				<Button icon="pi pi-plus" label="New" style={{ backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, marginRight: 10 }} onClick={() => this.setState({ selectedItem: new Fixture(), showItemInfoModal: true })}></Button>
				<Button className={this.state.viewMode === "list" ? "" : "p-button-outlined"} icon="pi pi-list" label="List" style={this.state.viewMode === "list" ? { backgroundColor: colours.primary, borderColor: colours.primary } : {}} onClick={() => this.setState({ viewMode: "list" })}></Button>
				<Button className={this.state.viewMode === "calendar" ? "" : "p-button-outlined"} icon="pi pi-calendar" label="Calendar" style={this.state.viewMode === "calendar" ? { backgroundColor: colours.primary, borderColor: colours.primary, marginLeft: 6 } : { marginLeft: 6 }} onClick={() => this.setState({ viewMode: "calendar" })}></Button>
				{/* <Button disabled={!this.state.selectedItems || !this.state.selectedItems.length} icon="pi pi-trash" label="Delete" style={{backgroundColor: colours.graphs.negative, borderColor: colours.graphs.negative, marginRight: 10}} onClick={() => this.setState({showDeleteSelectionModal: true})}></Button> */}
			</>
		);
	}

	renderRightToolbarButtons() {
		return (
			<>
				<div className="flex justify-content-between">
					<Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={() => { this.globalFilterChange("") }} />
					<span className="p-input-icon-left">
						<i className="pi pi-search" />
						<InputText value={this.state.globalFilter} onChange={(e) => { this.globalFilterChange(e) }} placeholder="Keyword Search" />
					</span>
				</div>
				<Button icon="pi pi-upload" label="Export" style={{ backgroundColor: colours.buttons.export, borderColor: colours.buttons.export, marginLeft: 10 }} onClick={() => this.dt?.exportCSV()}></Button>
			</>
		);
	}

	async saveItem() {
		this.setState({ isLoading: true });
		if (this.state.selectedItem.id === -1 || this.state.selectedItem.id === undefined) { // Create new
			const res = await safeJson(FixtureService.createSingle(this.state.selectedItem));
			if (res && res.error) {
				this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
				this.setState({ isLoading: false });
			}
			this.setState({ isLoading: false, showItemInfoModal: false });
			this.toast.show({ closable: false, detail: this.itemName + " has been created", life: 5000, severity: "success", summary: this.itemName + " created!" });
		} else { // Save existing
			const res = await safeJson(FixtureService.updateSingleById(this.state.selectedItem.id, this.state.selectedItem));
			if (res && res.error) {
				this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
				this.setState({ isLoading: false });
			}
			this.setState({ isLoading: false, showItemInfoModal: false });
			this.toast.show({ closable: false, detail: this.itemName + " has been saved", life: 5000, severity: "success", summary: this.itemName + " saved!" });
		}
		this.getItems();
	}

	async uploadImage(data: any, property: string) {
		const containerName = "uploads";
		const uploadData = new FormData();
		uploadData.append("containerName", containerName);
		uploadData.append("files", await ResizeImage(data.files[0]));
		uploadData.append("mimeTypeKey", "Images");
		const response = await safeJson(FileService.upload(uploadData));
		let selectedItem = { ...this.state.selectedItem };
		// @ts-ignore // Required to be able to change the values
		selectedItem[property] = `${environment.server.storageUrl}/${response[0].location}`;
		await this.setState({ selectedItem });
	}

}